import { FormattedMessage } from 'react-intl';

import { Content } from '#src/components/fiatWallet/CreateFiatWallet/Onboarding/Content/index.tsx';
import type { CreateFiatWalletSteps } from '#src/components/fiatWallet/CreateFiatWallet/type.ts';

type Props = {
  setStep: (tab: CreateFiatWalletSteps) => void;
  onDismiss?: () => void;
};
export const WhatsNew = (props: Props) => {
  const news = [
    {
      id: 'fiat',
      title: (
        <FormattedMessage defaultMessage="Preferred & flexible currency" />
      ),
      desc: (
        <FormattedMessage defaultMessage="Buy, sell, and receive rewards in cash. Or choose to use both cash and ETH/SOL." />
      ),
    },
    {
      id: 'deposit',
      title: (
        <FormattedMessage defaultMessage="Seamless deposits & withdrawals" />
      ),
      desc: (
        <FormattedMessage defaultMessage="Add cash using a credit/debit card, or opt for a bank transfer to easily add or withdraw funds." />
      ),
    },
  ];
  return (
    <Content
      {...props}
      news={news}
      title={<FormattedMessage defaultMessage="Introducing Cash Wallet" />}
    />
  );
};
